import { useAppVersionCheck } from '@/hooks/useAppVersionCheck';

export const AppVersionNotifier = () => {
  useAppVersionCheck();

  return null;
};
